import * as React from 'react';
import Map from '~/components/Map';
import GeoJSON from 'geojson';
import { MapEvent } from '~/config/map';
import { observer } from 'mobx-react';
import { LocationInfo, getPositionMapParams } from '@watcherr/resources';

type TPositionMapProps = {
  locationData?: LocationInfo;
  isStatic: boolean;
  type?: string;
  geofence?: GeoJSON.Feature<GeoJSON.Polygon>;
}

const PositionMap: React.FC<TPositionMapProps> = ({
  locationData,
  isStatic,
  type,
  geofence
}) => {
  const [isMapLoaded, setMapLoaded] = React.useState(false)
  const map = React.useRef<Map>(null);

  const params = React.useMemo(() => {
    if (!locationData) {
      return {};
    }
    return getPositionMapParams(locationData, isStatic)
  }, [locationData])

  React.useEffect(() => {
    if (isMapLoaded && geofence) {
      map.current?.sendEvent(MapEvent.SetOutdoorPolygon, geofence)
    }
  }, [geofence, isMapLoaded])

  React.useEffect(() => {
    if (params) {
      console.info("UpdateParams", "update", params)
      map?.current?.sendEvent(MapEvent.UpdateParams, params);
    }
  }, [params]);

  const startProps = React.useMemo(() => params, []);

  return (
    <>
      <Map
        ref={map}
        onMapLoaded={() => setMapLoaded(true)}
        page="map-position"
        type={type}
        {...startProps}
      />
    </>
  );
};

export default observer(PositionMap);
